import * as React from "react";
import { Box, Typography, Alert } from "@mui/material";
import DarkTextField from "./DarkTextField";
import AuthPrimaryButton from "./AuthPrimaryButton";
import { AUTH_TEXT_PRIMARY, AUTH_TEXT_SECONDARY, AUTH_ERROR } from "../theme/appTheme";
import { useTranslation } from "../i18n/LanguageContext";

const validateEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

// The email-only first step shared by /register and /forgot-password.
function EmailStepForm({ title, subtitle, submitLabel, onSubmit, loading, error, footer, initialEmail = "" }) {
  const { t } = useTranslation();
  const [email, setEmail] = React.useState(initialEmail);
  const [fieldError, setFieldError] = React.useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email) {
      setFieldError(t("auth.emailStep.emailRequired"));
      return;
    }
    if (!validateEmail(email)) {
      setFieldError(t("auth.emailStep.invalidEmail"));
      return;
    }
    setFieldError("");
    onSubmit(email);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Typography sx={{ fontWeight: 600, mb: 0.5, fontSize: "1.0625rem", color: AUTH_TEXT_PRIMARY }}>{title}</Typography>
      {subtitle && (
        <Typography sx={{ mb: 3, fontSize: "0.8125rem", color: AUTH_TEXT_SECONDARY }}>{subtitle}</Typography>
      )}

      <DarkTextField
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder={t("auth.login.emailPlaceholder")}
        autoFocus
      />
      {fieldError && (
        <Typography variant="caption" sx={{ color: AUTH_ERROR, mt: 0.5, display: "block" }}>
          {fieldError}
        </Typography>
      )}

      {error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      )}

      <AuthPrimaryButton type="submit" disabled={loading} sx={{ mt: 2.5 }}>
        {loading ? t("auth.registerDetails.submitting") : submitLabel}
      </AuthPrimaryButton>

      {footer && <Box sx={{ mt: 2.5, textAlign: "center" }}>{footer}</Box>}
    </form>
  );
}

export default EmailStepForm;
